import Nav from "../components/evgp/Nav";
import Hero from "../components/evgp/Hero";
import Marquee from "../components/evgp/Marquee";
import Progetto from "../components/evgp/Progetto";
import Programma from "../components/evgp/Programma";
import Scuole from "../components/evgp/Scuole";
import Social from "../components/evgp/Social";
import Sponsor from "../components/evgp/Sponsor";
import Logistica from "../components/evgp/Logistica";
import Footer from "../components/evgp/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-vg-black font-sans text-vg-white">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Progetto />
        <Programma />
        <Scuole />
        <Social />
        <Sponsor />
        <Logistica />
      </main>
      <Footer />
    </div>
  );
}
